export default __webpack_public_path__ + "static/media/shed.d45a0372.svg";